// Inert client-bundle stand-in for node:async_hooks — never executed in the
// browser (requestScopedStorage guards with isOnServer); it only has to resolve.
class AsyncLocalStorage {
	getStore() {
		return undefined
	}

	run(_store, callback, ...args) {
		return callback(...args)
	}
}

module.exports = { AsyncLocalStorage }
